window._cdnURL = "https://d2xw6c7kc53r26.cloudfront.net";